import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { IMAGES } from '../../constants/assets';
import SectionWrapper from '../SectionWrapper';
const Footer: React.FC = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#1c1c1c', // Dunkler Hintergrund ähnlich der Angular-Version
        color: 'white',
        py: 2.2,
        mt: 'auto', // Pushes footer to bottom
      }}
    >
        <SectionWrapper>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 2,
        }}
      >
        {/* Left section - Logos and branding */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
                         <img
               src={IMAGES.LOGO_WHITE}
               alt="DORAsmartCheck.ai"
               style={{ height: '20px' }}
             />
             <Typography sx={{ color: 'white', fontSize: '1rem' }}>
               &nbsp;&nbsp;|&nbsp;&nbsp;Ein Service von&nbsp;&nbsp;
             </Typography>
             <img
               src={IMAGES.MACROS_LOGO_WHITE}
               alt="Macros"
               style={{ height: '20px' }}
             />
          </Box>
        </Box>

        {/* Right section - Navigation links */}
        <Box
          sx={{
            display: 'flex',
            gap: 4,
          }}
        >
          <Link
            href="https://www.dorasmartcheck.ai/impressum"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: 'white',
              textDecoration: 'none',
              fontSize: '1rem',
              '&:hover': {
                textDecoration: 'underline',
              },
            }}
          >
            Impressum
          </Link>
          <Link
            href="https://www.dorasmartcheck.ai/datenschutz"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: 'white',
              textDecoration: 'none',
              fontSize: '1rem',
              '&:hover': {
                textDecoration: 'underline',
              },
            }}
          >
            Datenschutz
          </Link>
        </Box>
      </Box>
      </SectionWrapper>
    </Box>
  );
};

export default Footer; 